import React from "react";
import { SortingModalProps } from "./types";
import Modal from "@components/atoms/Modal";
import SortingFiltersScreen from "./SortingFiltersScreen";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";

const SortingFiltersModal = ({
  isOpen,
  onClose,
  productType,
  onApply,
  selectedSortingFilters,
  sectionName = SearchFilterTypeEnum.SINGLE_STONES,
}: SortingModalProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Modal
      headerTitle={t("sortingScreen.modal.title.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={theme.isMobile ? 0 : SpaceType.Basic}
      paddingRight={theme.isMobile ? 0 : SpaceType.Basic}
      paddingBottom={0}
      paddingTop={16}
      backgroundColor={theme?.["core-02"]}
      skipKeyboardAware={true}
      showScrollbar={false}
      noPadding
    >
      <SortingFiltersScreen
        onClose={onClose}
        productType={productType}
        onApply={onApply}
        selectedSortingFilters={selectedSortingFilters ?? []}
        sectionName={sectionName}
      />
    </Modal>
  );
};

export default SortingFiltersModal;
